import { TranslateService } from '@ngx-translate/core';
import { take, map } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { LanguageUtil } from 'src/app/util/language-util';
import { LanguageEnum } from 'src/app/enum/language-enum';

export class LanguageBase {

  arr: any[];

  private translateInit = 'envelope.settings.language.';

  constructor(private translate: TranslateService) {
  }

  public init(): Observable<any> {
    return this.translate.get([this.translateInit.concat(LanguageUtil.pt),
    this.translateInit.concat(LanguageUtil.en), this.translateInit.concat(LanguageUtil.es)]).pipe(
      take(1),
      map(x => {
        this.arr = [
          { id: 1, value: x[this.translateInit.concat(LanguageUtil.pt)] },
          { id: 2, value: x[this.translateInit.concat(LanguageUtil.en)] },
          { id: 3, value: x[this.translateInit.concat(LanguageUtil.es)] }
        ];
        return of();
      })
    );
  }

  public list(): Array<any> {
    return this.arr;
  }

  public getByLanguage(language) {
    let item = null;
    const lang = this.translate.instant(this.translateInit.concat(language));
    this.arr.some(x => {
      if (x.value === lang) {
        item = x;
      }
      return (x.value === lang);
    });
    return item;
  }

  public getDateFortmatByLanguageToCodex(language: string): string {
    switch (language) {
      case LanguageUtil.pt:
      case LanguageUtil.es:
        return 'dd/mm/yyyy';
      case LanguageUtil.en:
        return 'mm/dd/yyyy';
      default:
        return 'dd/mm/yyyy';
    }
  }

  public getDateFortmatByLanguage(language: string): string {
    switch (language) {
      case LanguageUtil.pt:
      case LanguageUtil.es:
        return 'dd/MM/yyyy';
      case LanguageUtil.en:
        return 'MM/dd/yyyy';
      default:
        return 'dd/MM/yyyy';
    }
  }

  public getDateFortmatByLanguageShortDescription(language: string): string {
    switch (language) {
      case LanguageUtil.pt:
      case LanguageUtil.es:
        return 'dd/MM/yyyy';
      case LanguageUtil.en:
        return 'MM/dd/yyyy';
      default:
        return 'dd/MM/yyyy';
    }
  }

  public getValue(id): string {
    switch (id) {
      case 1:
        return LanguageUtil.pt;
      case 2:
        return LanguageUtil.en;
      case 3:
        return LanguageUtil.es;
      default:
        return LanguageUtil.pt;
    }
  }

  public getValueByEnum(language: LanguageEnum): string {
    switch (language) {
      case LanguageEnum.portuguese:
        return LanguageUtil.pt;
      case LanguageEnum.english:
        return LanguageUtil.en;
      case LanguageEnum.spanish:
        return LanguageUtil.es;
      default:
        return LanguageUtil.pt;
    }
  }

  public getType(lang: string): string {
    switch (lang) {
      case LanguageUtil.pt:
        return 'pt-br';
      case LanguageUtil.en:
        return 'en-us';
      case LanguageUtil.es:
        return 'es';
      default:
        return 'pt-br';
    }
  }
}
